module.exports = __webpack_public_path__ + "media/images/countryrect/sg-ec71df2be4624d7991ee6550dedd8b13.svg";